import { PaymentSuccessBox } from "./PaymentSuccess.style";
// import { PaycurraLogo, PCButton } from "../../components";
import { useLocation } from "react-router-dom";
import { format, parseISO } from "date-fns";
import * as React from "react";
import { NumericFormat } from "react-number-format";
import { convertPriceToNaira } from "../../utils/helper";
import Lottie from "lottie-react";
import SuccessLottie from "../../assets/lottie/97240 success.json";
import { PyButton } from "../../components";
import { getSessionData } from "../../config";

export const PaymentSuccess = () => {
  const { state } = useLocation();
  const [loading, setLoading] = React.useState<boolean>(false);

  const closeWindow = async () => {
    setLoading(true);

    // Notify merchant of checkout status before closing the window
    notifyMerchantOfCheckoutStatus()
      .then(() => {
        // Clear cache after successful checkout
        localStorage.clear();
        sessionStorage.clear();

        //  Slight delay
        setTimeout(() => {
          // Back to marketplace
          window.close();
        }, 3500);
      })
      .catch((error) => {
        console.error("Error notifying merchant:", error);
        // Handle error (optional)
        window.close(); // Close window even if notification fails
      });
  };

  const notifyMerchantOfCheckoutStatus = (): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
      try {
        // Check if checkout is successful
        const checkoutStatus = localStorage.getItem("c_status");
        if (checkoutStatus === "true") {
          window.opener.postMessage("window_success", "*");
        } else {
          window.opener.postMessage("window_cancel", "*");
        }
        resolve(); // Resolve after message is sent
      } catch (error) {
        reject(error); // Reject if something goes wrong
      }
    });
  };

  const removeDash = (text: string) => {
    if (!text) return "";
    return text.split("-").join("");
  };

  const totalAmountPaid = () => {
    const cardAmount =
      (state && state?.paymentDetails?.cardTokenChargedResult?.amount) || 0;
    const rewardAmount =
      (state &&
        state?.paymentDetails?.rewardRedemptionResult?.discountApplied) ||
      0;
    const pointAmount =
      (state && state?.paymentDetails?.pointsRedemptionResult?.amount) || 0;

    return cardAmount + rewardAmount + pointAmount;
  };

  // console.log(state);

  const checkoutDetails =
    state && state?.paymentDetails?.data?.cardTokenChargedResult;
  const gateWayDetails = state && state?.gateWayDetails;

  return (
    <section className="flex justify-center items-center h-screen">
      <div className="col-xl-5 col-md-8">
        <PaymentSuccessBox>
          <div className="paymentContainer">
            <Lottie
              className="mx-auto d-block !mb-10 w-[100px] h-[100px] md:w-[200px] md:h-[200px]"
              animationData={SuccessLottie}
              loop={true}
            />

            <div className="headerContainer">
              <h3 className="title">Payment successful</h3>
              <div className="details">
                Your payment has been processed details of your transaction are
                included below
              </div>

              <div className="detailId">
                Transaction ID&nbsp;:&nbsp;
                {removeDash(
                  state?.paymentDetails?.sessionUniqueReferenceNumber
                ).substring(0, 12)}
              </div>
            </div>

            {/* <hr /> */}

            <ul className="transactDetailsGroup">
              <li className="detailsList">
                <div className="name">Total amount </div>
                <div className="value totalAmount">
                  <NumericFormat
                    value={convertPriceToNaira(totalAmountPaid())}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={gateWayDetails?.currencySymbol}
                  />
                </div>
              </li>

              <li className="detailsList">
                <div className="name">Paid by</div>
                {getSessionData() && (
                  <div className="value text-uppercase">
                    {getSessionData().name}
                  </div>
                )}
              </li>
              <li className="detailsList">
                <div className="name">Transaction Date </div>
                <div className="value">
                  {checkoutDetails?.transactionDate ? (
                    <>
                      {format(
                        parseISO(checkoutDetails?.transactionDate),
                        "dd MMM yyyy; hh:mm aa"
                      )}
                    </>
                  ) : (
                    <>{format(new Date(), "dd MMM yyyy; hh:mm aa")}</>
                  )}
                </div>
              </li>
            </ul>
          </div>

          <div className="d-flex justify-content-center">
            <PyButton loading={loading} click={closeWindow}>
              Return to Marketplace
            </PyButton>
          </div>

          <div className=""></div>
        </PaymentSuccessBox>
      </div>
    </section>
  );
};
